import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ButtonComponent, ModalComponent } from '@webapp/ui';
import { IUserSession } from '@webapp/auth';

@Component({
  selector: 'app-profile-sessions',
  standalone: true,
  imports: [DatePipe, ButtonComponent, ModalComponent],
  templateUrl: './profile-sessions.component.html',
  styleUrl: './profile-sessions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSessionsComponent {
  sessions = input<IUserSession[]>([]);
  loading = input<boolean>(false);
  canRevokeOthers = input<boolean>(false);
  sessionsError = input<boolean>(false);

  revokeOne = output<string>();
  revokeAll = output<void>();
  retry = output<void>();

  showRevokeOneModal = signal(false);
  showRevokeAllModal = signal(false);

  private targetSessionId = signal<string | null>(null);

  askRevokeOne(sid: string) {
    this.targetSessionId.set(sid);
    this.showRevokeOneModal.set(true);
  }

  closeRevokeOneModal() {
    this.showRevokeOneModal.set(false);
    this.targetSessionId.set(null);
  }

  confirmRevokeOne() {
    const sid = this.targetSessionId();
    this.showRevokeOneModal.set(false);
    this.targetSessionId.set(null);

    if (sid) {
      this.revokeOne.emit(sid);
    }
  }

  askRevokeAll() {
    this.showRevokeAllModal.set(true);
  }

  closeRevokeAllModal() {
    this.showRevokeAllModal.set(false);
  }

  confirmRevokeAll() {
    this.showRevokeAllModal.set(false);
    this.revokeAll.emit();
  }
}
